var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"qrCode"}},[_c('div',{attrs:{"id":"code"}}),_c('canvas',{attrs:{"id":"canvas"}}),_c('p',[_vm._v("请用微信扫描二维码")])])
}]

export { render, staticRenderFns }